export default function RecaptchaFunction() {
    this.RecaptchaFn = window.RecaptchaFunction;

    this.render = function (container, parameters) {
        return this.RecaptchaFn.render(container, parameters);
    };

    this.reset = function (opt_widget_id) {
        return this.RecaptchaFn.reset(opt_widget_id);
    };

    this.getResponse = function (opt_widget_id) {
        return this.RecaptchaFn.getResponse(opt_widget_id);
    };

    this.ready = function (callback) {
        return this.RecaptchaFn.ready(callback)
    }

    this.execute = function (key, parameters) {
        return this.RecaptchaFn.execute(key,parameters)
    }

}
